export enum CommentVisibility {
  Public = "public", // Everyone can see the comment
  Restricted = "restricted", // Only people with the right to read comment can read the comment
  Personal = "personal", // Only the creator of the comment can read the comment
}
